/* Feedback for the visible TeleTunes cart in both storefront layouts. */
(() => {
  const cartLink = document.querySelector('.tt-nav-cart');
  if (!cartLink) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const root = window.Shopify?.routes?.root || '/';
  const cartJsonUrl = `${root.endsWith('/') ? root : `${root}/`}cart.js`;
  let latestCountRequest = 0;
  let toastTimeout;

  function setCount(count, animate = false) {
    let badge = cartLink.querySelector('.tt-cart-count');
    if (count > 0 && !badge) {
      badge = document.createElement('span');
      badge.className = 'tt-cart-count';
      badge.setAttribute('aria-hidden', 'true');
      cartLink.appendChild(badge);
    }
    if (badge) {
      if (count > 0) badge.textContent = count > 99 ? '99+' : String(count);
      else badge.remove();
    }
    cartLink.setAttribute('aria-label', count > 0 ? `Cart (${count} ${count === 1 ? 'item' : 'items'})` : 'Cart');

    if (animate && !prefersReducedMotion.matches) {
      cartLink.classList.remove('tt-nav-cart--pulse');
      // Restart the animation when two items are added in quick succession.
      void cartLink.offsetWidth;
      cartLink.classList.add('tt-nav-cart--pulse');
    }
  }

  function showToast(message, isError = false) {
    let toast = document.querySelector('.tt-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'tt-cart-toast';
      document.body.appendChild(toast);
    }
    toast.replaceChildren();
    toast.classList.toggle('tt-cart-toast--error', isError);
    toast.setAttribute('role', isError ? 'alert' : 'status');

    const icon = document.createElement('span');
    icon.className = 'tt-cart-toast__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = isError ? '!' : '✓';

    const text = document.createElement('span');
    text.className = 'tt-cart-toast__message';
    text.textContent = message;
    toast.append(icon, text);

    if (!isError) {
      const link = document.createElement('a');
      link.href = `${root.endsWith('/') ? root : `${root}/`}cart`;
      link.textContent = 'View cart →';
      toast.appendChild(link);
    }

    toast.classList.add('tt-cart-toast--visible');
    window.clearTimeout(toastTimeout);
    toastTimeout = window.setTimeout(() => toast.classList.remove('tt-cart-toast--visible'), 4500);
  }

  async function getCartCount() {
    const response = await fetch(cartJsonUrl, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Cart count unavailable');
    const cart = await response.json();
    if (!Number.isInteger(cart.item_count)) throw new Error('Invalid cart count');
    return cart.item_count;
  }

  async function refreshCount(animate = false, fallbackAddition = 0) {
    const request = ++latestCountRequest;
    try {
      const count = await getCartCount();
      if (request === latestCountRequest) setCount(count, animate);
    } catch (error) {
      if (request === latestCountRequest && fallbackAddition > 0) {
        const current = Number.parseInt(cartLink.querySelector('.tt-cart-count')?.textContent || '0', 10) || 0;
        setCount(current + fallbackAddition, animate);
      }
    }
  }

  function flyToCart(source) {
    if (!source || prefersReducedMotion.matches || !source.isConnected) return Promise.resolve();
    const from = source.getBoundingClientRect();
    const to = cartLink.getBoundingClientRect();
    if (!from.width || !to.width) return Promise.resolve();

    const piece = document.createElement('span');
    piece.className = 'tt-cart-fly';
    piece.setAttribute('aria-hidden', 'true');
    piece.style.left = `${from.left + from.width / 2 - 12}px`;
    piece.style.top = `${from.top + from.height / 2 - 12}px`;
    document.body.appendChild(piece);

    const dx = to.left + to.width / 2 - (from.left + from.width / 2);
    const dy = to.top + to.height / 2 - (from.top + from.height / 2);
    const animation = piece.animate([
      { transform: 'translate(0, 0) scale(1)', opacity: 1 },
      { transform: `translate(${dx * 0.45}px, ${dy * 0.2 - 28}px) scale(1.15)`, opacity: 1, offset: 0.45 },
      { transform: `translate(${dx}px, ${dy}px) scale(0.35)`, opacity: 0.2 },
    ], { duration: 560, easing: 'cubic-bezier(.22,.65,.3,1)' });
    return animation.finished.catch(() => {}).finally(() => piece.remove());
  }

  async function added(source, quantity = 1) {
    showToast('Added to cart');
    await flyToCart(source);
    await refreshCount(true, quantity);
  }

  document.addEventListener('cart:update', (event) => {
    const data = event.detail?.data;
    if (data?.didError) {
      refreshCount();
      return;
    }
    if (data?.source === 'product-form-component') {
      const source = event.target?.querySelector?.('[ref="addToCartButton"]') || event.target;
      added(source, Number(data.itemCount) || 1);
    } else {
      refreshCount();
    }
  });

  document.addEventListener('tt:cart-added', (event) => added(event.detail?.source, 1));
  document.addEventListener('tt:cart-add-error', () => showToast("Couldn't add to cart. Please try again.", true));
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshCount();
  });
})();
